import createActions from '../config/actions/createActions';
import { action } from '@play-co/replicant';
import {
  buddiesGetEvent,
  buddiesIsEventCompleted,
  buddiesIsDummyPlayer,
} from './buddies.getters';
import {
  buddiesAddPlayerToParty,
  buddiesAddPartyPlayerScore,
  buddiesAddMainPlayerScore,
} from './buddies.modifiers';
import { buddiesDummyPrefix, buddiesMaxParty } from './buddies.ruleset';

/** Development mode only, not allowed in production */
export const buddiesCheats = createActions({
  /**
   * Fully reset buddies for the user
   */
  cheat_buddiesReset: action((state, _: void, api) => {
    delete state.bakingBuddies;
  }),

  /**
   * Add a dummy buddy to the next available party slot.
   * Dummy IDs: "Udummy-{slot}-{timestamp}" (e.g. "Udummy-1-1740000000000").
   */
  cheat_buddiesAddDummy: action((state, _: void, api) => {
    const now = api.date.now();
    const event = buddiesGetEvent(state, now);
    if (!event) return;

    const partySize = Object.keys(event.party).length;
    const slot = partySize + 1;
    if (slot > buddiesMaxParty - 1) return;

    const dummyId = `${buddiesDummyPrefix}${slot}-${now}`;
    buddiesAddPlayerToParty(state, { id: dummyId, now });
  }),

  /**
   * Add 15 score to the player in the given party slot (1, 2, or 3).
   */
  cheat_buddiesScoreBuddy: action((state, args: { slot: number }, api) => {
    const now = api.date.now();
    const event = buddiesGetEvent(state, now);
    if (!event) return;

    const partyIds = Object.keys(event.party).sort();
    const id = partyIds[args.slot - 1];
    if (!id) return;

    buddiesAddPartyPlayerScore(state, { id, score: 15, now });
  }),

  /**
   * Add score to the main player and notify party members.
   * Cancels all pending invites if grand prize is reached.
   */
  cheat_buddiesAddScore: action((state, args: { score: number }, api) => {
    const now = api.date.now();

    buddiesAddMainPlayerScore(state, { score: args.score, now });

    const event = buddiesGetEvent(state, now);
    if (!event) return;

    // Notify party members of score (skip dummy players)
    for (const id in event.party) {
      if (buddiesIsDummyPlayer(id)) continue;
      api.postMessage.buddiesAddPartyPlayerScore(id, {
        score: args.score,
      });
    }

    // If grand prize just reached, cancel all pending invites
    if (buddiesIsEventCompleted(state, now)) {
      for (const id in event.invites) {
        api.postMessage.buddiesRemoveInvite(id, {});
      }
      event.invites = {};
    }
  }),
});
